// extracted by mini-css-extract-plugin
export var errorIcon = "_nx-1";
export var nameLogo = "_nx-0";